import { render, staticRenderFns } from "./ParentInfo.vue?vue&type=template&id=d4994910&scoped=true"
import script from "./ParentInfo.vue?vue&type=script&lang=js"
export * from "./ParentInfo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ParentInfo.vue?vue&type=style&index=1&id=d4994910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4994910",
  null
  
)

export default component.exports